export const CISH_FINALIZADA = 'CISH_FINALIZADA';
export const cishFinalizada = cishFinalizada => ({
  type: CISH_FINALIZADA,
  payload: {
    cishFinalizada: cishFinalizada
  }
});



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/cish/cish.action.js